<template>
  <div
    :class="[
      'headerbar flex h-16 shrink-0 items-center gap-x-4 px-4 sm:gap-x-6 sm:px-6 lg:px-8',
      Capacitor.isNativePlatform() ? 'bg-gray-100' : 'border-b border-gray-200 bg-white shadow-sm'
    ]"
  >
    <ButtonComponent
      type="transparent"
      class="!p-0 text-gray-700 lg:hidden"
      :icon="['fal', 'bars']"
      screen-reader-text="open sidebar"
      text-class="text-gray-900"
      @clicked="navStore.setNavigationIsOpen(true)"
    />

    <div class="flex h-16 shrink-0 items-center lg:hidden">
      <RouterLink to="/" @click="navStore.setNavigationIsOpen(false)">
        <ImageComponent
          :alt="brand"
          :asset-info="{ name: brand, type: 'logo', extension: 'png' }"
          class="h-7 w-auto"
        />
      </RouterLink>
    </div>

    <div class="flex flex-1 justify-end gap-x-4 self-stretch lg:gap-x-6">
      <div class="mt-0.5 flex items-center">
        <NotificationCenterComponent />
      </div>
      <div class="flex items-center">
        <SecondaryNavigation />
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { useAppStore, useNavigationStore } from '@/stores'
import { Capacitor } from '@capacitor/core'

const navStore = useNavigationStore()
const appStore = useAppStore()

const brand = appStore.getBrand()
</script>
